








import { defineComponent } from '@vue/composition-api';
import { useAdCampaignItem } from '@/bundles/Ad/composables/useAdCampaignItem';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';
import { AdCampaignItemMediaType } from '@/bundles/Ad/types';
import { IUpdateAdItemInfoDto } from '@/bundles/Ad/dto';

import AdItemFormBase from '@/bundles/Ad/components/AdItemFormBase.vue';

export default defineComponent({
  name: 'AdItemCreateForm',

  components: {
    AdItemFormBase,
  },

  emits: ['form:close', 'item:refresh'],

  props: {
    campaignId: {
      type: Number,
      required: true,
    }
  },

  setup (props, { emit }) {
    const { defaultItemData, assignAdItem, createLoading } = useAdCampaignItem();
    const adItem = new AdCampaignItem(defaultItemData);
    async function updateEventHandler ({  url, files, media_type }: { url: string; files: File[]; media_type?: AdCampaignItemMediaType }) {
      const payload: IUpdateAdItemInfoDto = { url };
      if (files.length) {
        payload.media = files;
      }
      payload.media_type = media_type;
      await assignAdItem(props.campaignId, payload);
      emit('form:close');
      emit('item:refresh');
    }

    return {
      adItem,
      createLoading,
      updateEventHandler,
    };
  },
});
